import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/")) {
      localStorage.removeItem("rr_token");
      if (window.location.hostname.endsWith(".areapaq.it")) {
        window.location.href = "https://areapaq.it/login";
        return new Promise(() => {});
      }
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore imprevisto";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatEuro = (v) => `€ ${Number(v || 0).toFixed(2)}`;

export const imageUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/images/${path}`;

export default api;
